import { createIcon } from '@chakra-ui/icons';

export const BarChart = createIcon({
  displayName: 'BarChart',
  viewBox: '0 0 14 15',
  path: [
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.16667 1.76752H5.83333C5.51133 1.76752 5.25 2.02885 5.25 2.35085V12.8509C5.25 13.1728 5.51133 13.4342 5.83333 13.4342H8.16667C8.48867 13.4342 8.75 13.1728 8.75 12.8509V2.35085C8.75 2.02885 8.48867 1.76752 8.16667 1.76752Z"
        fill="currentColor"
      />
      <path
        d="M2.91667 8.1842H0.583333C0.261333 8.1842 0 8.44554 0 8.76754V12.8509C0 13.1729 0.261333 13.4342 0.583333 13.4342H2.91667C3.23867 13.4342 3.5 13.1729 3.5 12.8509V8.76754C3.5 8.44554 3.23867 8.1842 2.91667 8.1842Z"
        fill="currentColor"
      />
      <path
        d="M13.4167 5.26752H11.0833C10.7613 5.26752 10.5 5.52885 10.5 5.85085V12.8509C10.5 13.1729 10.7613 13.4342 11.0833 13.4342H13.4167C13.7387 13.4342 14 13.1729 14 12.8509V5.85085C14 5.52885 13.7387 5.26752 13.4167 5.26752Z"
        fill="currentColor"
      />
    </svg>,
  ],
});
